module.exports = __webpack_public_path__ + "jpg.png?f06cb75fc2fe43cbea187c0d2caca9ff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconImg/jpg.png
// module id = 123
// module chunks = 0